import { render, staticRenderFns } from "./OrderSelectItem.vue?vue&type=template&id=1d71b882&scoped=true&"
import script from "./OrderSelectItem.vue?vue&type=script&lang=js&"
export * from "./OrderSelectItem.vue?vue&type=script&lang=js&"
import style0 from "./OrderSelectItem.vue?vue&type=style&index=0&id=1d71b882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d71b882",
  null
  
)

export default component.exports